import React, { useEffect, useRef, useState } from 'react';
import './PayrollHeroAnimatedText.css';

const PayrollHeroAnimatedText = ({
  as: Tag = 'span',
  text,
  className = '',
  variant = 'from-left',
  threshold = 0.18,
  rootMargin = '0px 0px -10% 0px',
  step = 22,
  delay = 0,
}) => {
  const textRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentNode = textRef.current;

    if (!currentNode) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold,
        rootMargin,
      }
    );

    observer.observe(currentNode);

    return () => observer.disconnect();
  }, [rootMargin, threshold]);

  let letterOrder = 0;

  return (
    <Tag
      ref={textRef}
      className={`payroll-hero-animated-text payroll-hero-animated-text--${variant}${isVisible ? ' is-visible' : ''}${className ? ` ${className}` : ''}`}
      style={{
        '--payroll-letter-step': `${step}ms`,
        '--payroll-letter-delay': `${delay}ms`,
      }}
    >
      <span className="payroll-hero-sr-only">{text}</span>
      <span className="payroll-hero-text-visual" aria-hidden="true">
        {text.split(' ').map((word, wordIndex) => {
          const letters = Array.from(word);
          const startIndex = letterOrder;

          letterOrder += letters.length;

          return (
            <React.Fragment key={`${word}-${wordIndex}-${startIndex}`}>
              {wordIndex > 0 ? ' ' : null}
              <span className="payroll-hero-word">
                {letters.map((letter, letterIndex) => (
                  <span
                    key={`${word}-${letterIndex}`}
                    className="payroll-hero-letter"
                    style={{ '--payroll-letter-index': startIndex + letterIndex }}
                  >
                    {letter}
                  </span>
                ))}
              </span>
            </React.Fragment>
          );
        })}
      </span>
    </Tag>
  );
};

export default PayrollHeroAnimatedText;
